import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Sector, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { useNavigate } from 'react-router-dom';
import { useSentimentAnalysisApi } from '../../store/api/hooks/sentimentAnalysisApiHook';
import { useAuthStatus, useStoreSelector, useStoreBrnDSSelector } from '../../store/selectors/userSelector';
import { toast } from 'react-hot-toast';
import moment from 'moment';
import { set } from 'date-fns';


const SentimentOverall = ({ filterValue }: { filterValue: any }) => {
    const [sentimentOverall, setSentimentOverall] = useState<any>({});
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const sentimentAPI: any = useSentimentAnalysisApi();
    const navigate = useNavigate();
    const isAuth = useAuthStatus();
    const branchDS = useStoreBrnDSSelector();
    // console.log('useEffect =>', branchDS);

    useEffect(() => {
        if (filterValue !== null) {
            applyFilter(filterValue); // This is called automatically when filterValue changes
        } else {
            getSentimentOverall({});
        }
    }, [filterValue]);

    const applyFilter = (filterValue: any) => {
        // console.log('filterValue =>', filterValue);
        getSentimentOverall(filterValue);
    }


    const getSentimentOverall = (param: any) => {
        setOnSubmitLoading(true);
        let params: any;
        if (param) {
            params = { branch_id: branchDS?.branch_id, ...param };
        } else {
            params = { branch_id: branchDS?.branch_id };
        }
        try {
            setTimeout(() => {
                sentimentAPI.getSentimentOverall(params, (msg: any, resp: any) => {
                    setSentimentOverall(resp.data);
                }, (err: any, resp: any) => {
                    toast.error(resp?.detail?.message);
                })
                setOnSubmitLoading(false);
            }, 3000);
        } catch (err: any) {
            toast.error(err);
            setOnSubmitLoading(false);
        }
    }


    const data = [
        { name: 'A', value: 40, color: '#f87171' },
        { name: 'B', value: 40, color: '#e69d89' },
        { name: 'C', value: 40, color: '#EED202' },
        { name: 'D', value: 40, color: '#cad943' },
        { name: 'E', value: 40, color: '#a2c977' },
        { name: 'F', value: 40, color: '#82ca9d' },
    ];
    const cx = 150;
    const cy = 200;
    const iR = 85; // 50;
    const oR = 100;
    const value = sentimentOverall?.sentiment_score ?? 0; // 50;

    const RADIAN = Math.PI / 180;

    const needle = (value: number, data: { name: string; value: number; color: string }[], cx: number, cy: number, iR: number, oR: number, color: string) => {
        let total = 100;
        // data.forEach((v) => {
        //     total += v.value;
        // });

        const ang = 180.0 * (1 - value / total);

        const length = (iR + 2 * oR) / 3;

        const sin = Math.sin(-RADIAN * ang);
        const cos = Math.cos(-RADIAN * ang);

        const r = 5;
        const x0 = cx + 5;
        const y0 = cy + 5;

        const xba = x0 + r * sin;
        const yba = y0 - r * cos;
        const xbb = x0 - r * sin;
        const ybb = y0 + r * cos;

        const xp = x0 + length * cos;
        const yp = y0 + length * sin;

        return [
            <circle key="needle-circle" cx={x0} cy={y0} r={r} fill={color} stroke="none" />,
            <path key="needle-path" d={`M${xba} ${yba}L${xbb} ${ybb} L${xp} ${yp} L${xba} ${yba}`} stroke="#none" fill={color} />,
        ];
    };


    return (
        <>
            <div className="p-6 mb-5 flex-1 flex flex-col justify-center items-center">

                <PieChart width={300} height={350}>
                    <Pie
                        dataKey="value"
                        startAngle={180}
                        endAngle={0}
                        data={data}
                        cx={cx}
                        cy={cy}
                        innerRadius={iR}
                        outerRadius={oR}
                        paddingAngle={3}
                        fill="#8884d8"
                        stroke="none"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                    {needle(value, data, cx, cy, iR, oR, '#d0d000')}
                </PieChart>
                <div className="-mt-[90px]"> {/* Add margin-top to separate from the chart */}
                    <h1 className="text-sm text-gray-400">Sentiment Score: {value ? value.toFixed(2) : 0}</h1>
                </div>
            </div>
        </>
    )



};

export default SentimentOverall;
